import { useRef, useEffect } from 'react';

import { CallbackType } from '@web/common/types/CallbackType';
import { debounce } from '@web/common/utils/debounce';

type ConfigType = {
  noDebounce?: boolean;
};

export default function useWindowResize(callback: CallbackType, config?: ConfigType): void {
  const onResizeRef = useRef(null);

  useEffect(() => {
    if (onResizeRef.current) {
      return;
    }

    if (!callback || typeof callback !== 'function') {
      console.warn('Incorrect callback passed to useWindowResize');
      return;
    }

    const onResize = config?.noDebounce ? callback : debounce(callback, 400);
    onResizeRef.current = onResize;

    window.addEventListener('resize', onResize);
    return (): void => window.removeEventListener('resize', onResize);
  }, [callback, config?.noDebounce, onResizeRef]);
}
